import * as React from "react"
import {Skeleton} from "@mui/material"

import {useToast} from "@hooks";
import { TitleWithPopover, AppTableSeeker } from "@components"
import {usePriceDiscountTopData, usePriceDiscountTopText} from "./@hooks";
import {discountColumn, numDaysColumn, retailerColumn, skuColumn} from "./columns"
import {usePricingDiscountRoleConfig} from "../../@hooks";


export default function PriceTopDiscount() {
	const { urlApi } = usePricingDiscountRoleConfig()
	const { isLoading, data } = usePriceDiscountTopData()
	const { title, column, isRetailerUser } = usePriceDiscountTopText()
	const { showToast } = useToast()
	const HEIGHT =  isRetailerUser ? 800 : 500

	if (isLoading) return <Skeleton variant="rectangular" height={HEIGHT} />
	if (!data.length) return <></>

	return <AppTableSeeker
		title={<TitleWithPopover title={title} />}
		data={data}
		columns={[
			retailerColumn(),
			skuColumn(),
			discountColumn(column),
			numDaysColumn()
		]}
		theme={{
			MUIDataTable: {
				styleOverrides:{ root: { height: "100%" } }
			}
		}}
		options={{
			onDownload: () => showToast.promiseExcel(`${urlApi}/top-discount/excel`),
			tableBodyHeight: `${HEIGHT}px`,
			search: false,
			print: false,
			filter: false,
			viewColumns: false,
			rowsPerPageOptions: [5, 10]
		}}
	/>

}